module.exports = __webpack_public_path__ + "static/mr-press-29-1448a36d592907656a9f927d0b59beee.jpg";